import { useEffect } from 'react';

export function useLockBodyScroll(isLocked) {
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;

    console.log(isLocked ? '[lock]' : '[unlock]');
    html.classList.toggle('overflow-hidden', isLocked);
    body.classList.toggle('overflow-hidden', isLocked);

    return () => {
      console.log('[cleanup]');
      html.classList.remove('overflow-hidden');
      body.classList.remove('overflow-hidden');
    };
  }, [isLocked]);
}